"use client";

import { PricingTierCards } from "@/components/pricing/PricingTierCards";

export function LandingPricing() {
  return <PricingTierCards inAppCheckout />;
}
